import { generatePath } from 'react-router';
import { all, call, takeEvery } from 'redux-saga/effects';

import { PATH } from 'constants/RoutesConstants';
import { simpleRequestsLoader } from 'modules/app/utils';

import * as actions from 'modules/appointments/actions';
import * as detailsActions from 'modules/appointments/actions/details';
import * as actionTypes from 'modules/appointments/actionTypes';
import { navigate } from 'modules/router/navigate';

import { actionFormatter, patchStatusMessageId } from '../utils';

function* redirectToDetailsPage({ payload }) {
  yield call(navigate, generatePath(PATH.KEY_DROP_OFF_APPOINTMENTS_DETAILED.path, { appointmentId: payload.id }));
}

const simpleRequests = {
  [actionTypes.FETCH_APPOINTMENT_REQUEST]: {},
  [actionTypes.FETCH_ATTENTION_POINTS_REQUEST]: {},
  [actionTypes.FETCH_EVENTS]: {
    callbacks: { success: actionFormatter(detailsActions.fetchEventsSuccess) },
  },
  [actionTypes.READ_MESSAGES]: {
    callbacks: { success: (_, meta, { payload }) => detailsActions.readMessagesSuccess(payload.id, meta) },
  },
  [actionTypes.FETCH_SHARE_LINK]: {
    callbacks: { success: actionFormatter(detailsActions.fetchShareLinkSuccess) },
  },
  [actionTypes.FETCH_INTERVENTION]: {
    callbacks: { success: actionFormatter(detailsActions.fetchInterventionSuccess) },
  },
  [actionTypes.PUT_REQUEST]: {
    callbacks: { success: actions.putSuccess, failure: actions.putFailure },
    notifications: {
      success: {
        id: 'page.fiche.notification.update_appointment.success',
        defaultMessage: 'Appointment updated',
      },
      failure: {
        id: 'page.fiche.notification.update_appointment.failure',
        defaultMessage: "Can't update the appointment",
      },
    },
  },
  [actionTypes.POST_REQUEST]: {
    notifications: {
      success: {
        id: 'page.keyDeposit.appointments.createModal.success',
        defaultMessage: 'Appointment added',
      },
    },
  },
  [actionTypes.DELETE_REQUEST]: {
    callbacks: {
      success: (_, __, parentAction) => actions.deleteSuccess(parentAction.payload.request.params.id),
    },
    notifications: {
      success: { id: 'page.fiche.notification.delete_appointment.success', defaultMessage: 'Appointment deleted' },
      failure: {
        id: 'page.fiche.notification.delete_appointment.failure',
        defaultMessage: "Can't delete the appointment",
      },
    },
  },
  [actionTypes.PATCH_STATUS_REQUEST]: {
    notifications: {
      success: (_, action) => ({ id: patchStatusMessageId(action.payload.request.data.status) }),
      failure: (_, action) => ({ id: patchStatusMessageId(action.payload.request.data.status, true) }),
    },
  },
};

export default function* appointmentCoreSagas() {
  yield takeEvery(actionTypes.POST_SUCCESS, redirectToDetailsPage);
  yield all(simpleRequestsLoader(simpleRequests));
}
